import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { valibotResolver } from '@hookform/resolvers/valibot';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useMentorshipSchema } from 'src/modules/mentorship/components/mainForm/useMentorshipSchema';
import { useMentorshipDefaultValues } from 'src/modules/mentorship/hooks/useDefaultValues';
import { useSubmitMentorship } from 'src/modules/mentorship/hooks/useSubmitMentorship';
import { Drawer, DrawerHeader, DrawerBody, DrawerFooter } from 'src/shared/components/drawer';
import { DrawerHelper } from 'src/shared/components/drawer/helper';
import { usePreventLeave } from 'src/shared/components/preventLeaveModal/hooks/usePreventLeave';
import { PreventLeaveModal } from 'src/shared/components/preventLeaveModal/preventLeaveModal';
import { Routes } from 'src/shared/constants/routes';
import { Body } from './body';
import { Footer } from './footer';
import { Header } from './header';
export function Dialog({ isUpdate }) {
    const navigate = useNavigate();
    const [opened, setOpened] = useState(true);
    const defaultValues = useMentorshipDefaultValues();
    const form = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: valibotResolver(useMentorshipSchema())
    });
    const { isValid, isDirty, dirtyFields } = form.formState;
    const handleLeaveConfirmation = useCallback(() => {
        setOpened(false);
        const queryString = window.location.search;
        DrawerHelper.listenerOnClose(() => navigate(`${Routes.ListModules}${queryString}`));
    }, [navigate]);
    const { handleLeave, preventLeaveModalProps } = usePreventLeave({
        onLeaveConfirmation: handleLeaveConfirmation,
        dirtyFields
    });
    const { submit, isPending } = useSubmitMentorship({
        isUpdate,
        onSubmitSuccess: () => setOpened(false)
    });
    return (_jsx(FormProvider, { ...form, children: _jsxs(Drawer, { opened: opened, type: "bottomsheet", onCloseDrawer: handleLeave, children: [_jsx(DrawerHeader, { children: _jsx(Header, { isUpdate: isUpdate }) }), _jsxs(DrawerBody, { className: "overflow-y-scroll", children: [_jsx(Body, { submit: submit }), _jsx(PreventLeaveModal, { ...preventLeaveModalProps })] }), _jsx(DrawerFooter, { children: _jsx(Footer, { isUpdate: isUpdate, isLoading: isPending, isSubmitDisabled: !isDirty || !isValid || isPending }) })] }) }));
}
